<form
  #form
  fsForm
  [submit]="save"
  [dirtySubmitButton]="false"
  *fsSkeletonForm="environmentCreate">
  <mat-card-content>
    <h1>
      Who else should we invite?
    </h1>
    @for (item of environmentCreate.members; track item; let index = $index) {
      <div
        class="fs-row.gap-sm"
        >
        <mat-form-field class="full-width">
          <mat-label>
            Email
          </mat-label>
          <input
            matInput
            [(ngModel)]="item.email"
            name="email_{{ item.guid }}"
            fsFormEmail="true">
        </mat-form-field>
        <mat-form-field>
          <mat-label>
            Role
          </mat-label>
          <mat-select
            [(ngModel)]="item.aclRoleReference"
            name="acl_role_id_{{ item.guid }}">
            @for (aclRoleReference of aclRoleReferences; track aclRoleReference) {
              <mat-option
                [value]="aclRoleReference.value">
                {{ aclRoleReference.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </mat-card-content>
  <mat-card-actions>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      class="full-width">
      Continue
    </button>
  </mat-card-actions>
</form>